import React from 'react';
import { useScreenInit } from '../useScreenInit';
import { Header } from './Header';
import { HeroSystem } from './HeroSystem';
import { MobileCheckoutBar } from './MobileCheckoutBar';
import { OfferLearning } from './OfferLearning';
import { RecipesAccess } from './RecipesAccess';
import { TrustFooter } from './TrustFooter';
export function LandingPage() {
  useScreenInit();
  return <div className="min-h-screen w-full overflow-hidden bg-[#fcfbf7] text-[#344833]" data-id="element-164" data-mp="pn1tb86tbxw6">
      <Header data-id="element-165" data-mp="kwlfhmz2ya9a" />
      <main data-id="element-166" data-mp="kwv5vbo1ejfi">
        <HeroSystem data-id="element-167" data-mp="kwbn5sqkbr0f" />
        <OfferLearning data-id="element-168" data-mp="kvtjwc5hgcj0" />
        <RecipesAccess data-id="element-169" data-mp="kuifqb84l2rd" />
        <TrustFooter data-id="element-170" data-mp="fxiau3n0i61u" />
      </main>
      <MobileCheckoutBar data-id="element-171" data-mp="fyjxl5de4gze" />
    </div>;
}